
import { Options, Vue } from "vue-class-component";
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaService from "@/service/v1/sigap/AulaService";
import FaltaService from "@/service/v1/sigap/FaltaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const authStore = namespace("auth");
import BotaoSalvar from "@/components/aplicacao/BotaoSalvar.vue";

@Options({
    name: "FaltaLoteIndex",
    components: { CardRh, KDataTable, Multiselect, BotaoSalvar },
})
export default class FaltaLoteIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    public faltaService = new FaltaService();
    public FaltaMotivo = null;
    public motivos: any = [];
    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.FaltaMotivo = null;
        this.refreshTable();
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get motivos_select() {
        return this.motivos.map((item) => {
            return { value: item.id, label: item.nome.replaceAll("_", " ") };
        });
    }

    public buscarFaltaMotivos() {
        this.faltaService.getMotivo()
            .then(response => {
                this.motivos = response;
            });
    }

    protected salvarLote() {
        SiteUtils.alertConfimacao("Confirma a Insercao de todas as faltas? ", "",
            () => {
                this.salvar();
            }
        );
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) { return; }
        this.processando = true;
        const dados = {
            MatriculaId: this.matricula.id,
            FaltaMotivo: this.FaltaMotivo,
            DataMin: this.data_min,
            DataMax: this.data_max,
        };
        setTimeout(() => {
            this.faltaService.cadastrarLote(dados)
                .then(response => {
                    SiteUtils.toastSucesso("Falta adicionada com successo.! ", response.message);
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro("Error! ", error.data.message);
                });
        }, 100);
    }

    created() {
        this.buscarFaltaMotivos();
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.data_min = this.hj;
        this.service = new AulaService();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    pelotao: this.matricula.pelotao,
                    turmaId: this.matricula.turmaId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[4, 'desc'],[1, 'desc']];
        this.config.columns = [
            { data: "id", name: "id", searchable: false },
            { data: "numero", name: "numero", class: "desktop", searchable: false },
            { data: "disciplina", name: "disciplina", searchable: false },
            { data: "aulaDisciplina", name: "auladisciplina", searchable: false , orderable: false},
            { data: "data", name: "data", class: "desktop", searchable: false },
            { data: "instrutor", name: "instrutor", class: "desktop", searchable: false },
            { data: "status", name: "status", searchable: false, class: "text-center desktop" },
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row, type, val) => {
                    return row + "/" + val.disciplina.cargaHoraria;
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row != null ? row.pelotao : "";
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row != null ? row.nome : "";
                }
            },
            {
                targets: 6,
                render: (row) => {
                    return row.nome ?? "";
                }
            },
        ];
    }
}
